import DeleteItemButton from './DeleteItemButton.vue';


export default {
  __name: 'MedicationItem',
  props: {
    id: {
        type: Number,
        required: true,
    },
    field: {
        type: Object,
        required: true,
    },
},
  emits: ['removeItem'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props;





const remove = () => {
    emit('removeItem', props.id);
};

const mapValues = {
    '1x1': '1 opakowanie',
    '2x1': '2 opakowania',
    '3x1': '3 opakowania',
};

const __returned__ = { props, emit, remove, mapValues, DeleteItemButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}